module.exports = __webpack_public_path__ + "static/img/contant_3.fd61a4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/contant_3.jpg
// module id = nxVm
// module chunks = 0